import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { SubAgentEditFieldsKey } from 'stores/global/RootStore/AppConfigStore';
import { SubAgentStore } from 'stores/local/shared/SubAgentStore';

import FieldPhone from '../form/FieldPhone';
import FieldText from '../form/FieldText';

type SubAgentEditFormProps = {
  className?: string;
  store: SubAgentStore;
};

const SubAgentEditForm: React.FC<SubAgentEditFormProps> = ({ className, store }) => {
  return (
    <Stack className={className} gap="xl">
      {store.fieldsMap[SubAgentEditFieldsKey.phone].shown && (
        <FieldPhone data-autofocus label="Телефон" store={store.fieldsMap[SubAgentEditFieldsKey.phone]} />
      )}
      {store.fieldsMap[SubAgentEditFieldsKey.firstName].shown && (
        <FieldText label="Имя" store={store.fieldsMap[SubAgentEditFieldsKey.firstName]} />
      )}
      {store.fieldsMap[SubAgentEditFieldsKey.lastName].shown && (
        <FieldText label="Фамилия" store={store.fieldsMap[SubAgentEditFieldsKey.lastName]} />
      )}
      {store.fieldsMap[SubAgentEditFieldsKey.patronymic].shown && (
        <FieldText label="Отчество" store={store.fieldsMap[SubAgentEditFieldsKey.patronymic]} />
      )}
      {store.fieldsMap[SubAgentEditFieldsKey.email].shown && (
        <FieldText label="Электронная почта" store={store.fieldsMap[SubAgentEditFieldsKey.email]} />
      )}
    </Stack>
  );
};

export default observer(SubAgentEditForm);
